<script>
export default {
  name: 'candela-grid-lines',
  props: {
    axis_x: {type: Object, default: () => null},
    axis_y: {type: Object, default: () => null}
  }
}
</script>

<template>
<g v-if='axis_x && axis_y' class='candela-grid-lines'>
  <!-- TODO: Make tick number variable -->
  <!-- vertical lines -->
  <g>
    <line v-for='(t, i) in axis_x.tick_values' :key='`x-${i}`'
      :x1='Math.floor(axis_x.tick_x_1(t))'
      :x2='Math.floor(axis_x.tick_x_2(t))'
      :y1='axis_y.scale.range()[0]'
      :y2='axis_y.scale.range()[1]'
      class='grid-line-x'/>
  </g>

  <!-- horizontal lines -->
  <g>
    <line v-for='(t, i) in axis_y.tick_values' :key='`y-${i}`'
      :x1='axis_x.scale.range()[0]'
      :x2='axis_x.scale.range()[1]'
      :y1='Math.floor(axis_y.tick_y_1(t))'
      :y2='Math.floor(axis_y.tick_y_2(t))'
      class='grid-line-y'
      stroke-dasharray='5,5'/>
  </g>
</g>
</template>

<style lang='sass' scoped>
.theme--dark
  .grid-line-x
    stroke: var(--v-grey-darken8)

  .grid-line-y
    stroke: var(--v-grey-darken7)

.theme--light
  .grid-line
    stroke: var(--v-grey-base)
</style>
